import { BaseService } from './base-service'
import { HttpMethod } from '@/utils/http-client'
import { Observable } from 'rxjs'
import { ThirdCustomer, ThirdCustomerChannel, OpeningPreview, OpeningCommand, OpeningOperation } from '@/api/model/third-customer'

export class ThirdCustomerService extends BaseService {
    list(data): Observable<{ list: ThirdCustomer[], total: number }> {
        return this.post('list', data)
    }
    channels(): Observable<ThirdCustomerChannel[]> {
        return this.post('channels', {})
    }
    preview(data: { mid: string, channelId: number }): Observable<OpeningPreview> {
        return this.post('preview', data)
    }
    open(data: OpeningCommand): Observable<ThirdCustomer> {
        return this.post('open', data)
    }
    refresh(data: { recordId: string, mid: string, channelId: number }): Observable<ThirdCustomer> {
        return this.post('refresh', data)
    }
    history(recordId: string): Observable<OpeningOperation[]> {
        return this.post('history', { recordId })
    }
    private post(action: string, data): Observable<any> {
        return this.requestPmc({ url: '/front/thirdCustomer/' + action, method: HttpMethod.POST, data })
    }
}
